export const translation = {
  SEARCH_CATALOG: "Buscar en el catálogo",
  MY_SETUP: "Mi perfil",
  CONTACT_US: "Contacto",
  HELP: "Ayuda",
  LOGOUT: "Cerrar sesión",
  ORDER_FAVORITES: "Pedir favoritos",
  QUICK_ORDER: "Pedido rápido",
  ORDER_BANDS: "Pedir bandas",
  CATALOG: "Catálogo",
  SAVED_CARTS: "Carritos guardados",
  MY_CART: "Mi carrito",
  MY_ORDERS: "Mis pedidos",
  MY_STATEMENT: "Mis extractos",
  WELCOME: "Bienvenido",
  LOGIN_ID: "Usuario",
  ACCOUNT_NUMBER: "Número de cuenta Solventum",
  ADDRESS: "Dirección",
  PHONE: "Teléfono",
  FAX: "Fax",
  PRICE_DISCOUNT: "Descuento de precios",
  SHOW_CUSTOMER_DETAILS: "Mostrar detalles del cliente",
  HIDE_CUSTOMER_DETAILS: "Ocultar detalles del cliente",
  MY_REWARDS: "Mis recompensas",
  PRODUCTS: "Productos",
  YOUR_PRODUCTS: "Mis productos",
  MANAGE_ACCOUNTS: "Administrar cuentas",
  //CATALOG PAGE
  PRODUCTS: "Productos",
  HOME: "Inicio",
  //Saved Carts
  CART_NUMBER: "N.º de carrito",
  CART_NAME: "Nombre del carrito",
  LAST_UPDATED: "Última actualización",
  TOTAL: "Total",
  ACTIONS: "Acciones",
  SAVED_CARTS: "Carritos  guardados",
  CREATE_CART: "Crear carrito",
  VIEW_CART_DETAILS: "Ver detalles del carrito",
  SET_AS_CURRENT_CART: "Establecer como carrito actual",
  RENAME_CART: "Cambiar nombre del carrito",
  DELETE_CART: "Eliminar carrito",
  ACTIVE_CART_MESSAGE: "Este es su carrito activo",
  LOCK_CART_MESSAGE: "Este carrito está bloqueado por el usuario",
  RENAME: "Cambiar nombre",
  DELETE: "Eliminar",
  CANCEL: "Cancelar",
  PRIVATE_CART_MESSAGE:
    "Este carro es privado. Desbloquea este carro para que otras personas puedan verlo.",
  UNLOCK_CART: "Desbloquear carro",
  TAKE_OVER_LOCK: "Bloqueo de toma de control",
  LOCK_CART: "Bloquear carro",
  CART_NAME: "Nombre del carrito",
  LOCK_CART_SELF_MESSAGE:
    "Has bloqueado este carro. Nadie más puede editar este carro.",
  CREATE: "Crear",
  CUSTOMER_SUPPORT: "Apoyo al cliente",
  YOUR_ACCOUNT: "Mi cuenta",
  ITEMS: "Artículos",
  //Product Details Page
  OVERVIEW: "Resumen",
  SPECIFICATIONS: "Especificaciones",
  DETAILS: "Detalles",
  VIEW_LEGAL_DISCLAIMER: "Ver el aviso legal",
  PRODUCTS_AVAILABLE: "Productos disponibles",
  THREEM_SITE_REDIRECT_MSG: "Haga clic aquí para ver este producto en Solventum.com",
  LEGAL_DISCLAIMER: "Aviso legal",
  ENDORSEMENT_MSG:
    "*Versión Solventum de esta receta. No se implica ningún respaldo por parte del Doctor.",
  SEARCH_RESULTS_FOR: "Resultados de la búsqueda de",
  CATALOG_PRODUCT: "Catálogo",
  SEARCH_RESULTS: "Resultados de búsqueda",
  //My Rewards Page
  SAVINGS_THIS_YEAR: "ahorro este año",
  CURRENT_3M: "Estado actual de descuentos ganados por los alineadores",
  TM: "",
  CLARITY: "",
  DISCOUNT_STATUS: "Solventum Clarity",
  CLARITY_ALIGNERS_CASES: "Casos de alineadores Clarity",
  OTHER_PRODUCT_PURCHASES: "Otras compras de productos",
  SPEND: "Gaste",
  IN_PRODUCT_PURCHASES: "en compras de productos",
  ADD: "Añadir",
  OR: "OR",
  CLARITY_ALIGNERS_ORDERS: "casos de alineadores Clarity",
  DATE: "Fecha",
  INVOICE_NUMBER: "Número de factura",
  ORDER_NUMBER: "Número de pedido",
  QUALIFYING_CASES: "Casos aptos",
  QUALIFYING_PURCHASES: "Compras que califican",
  OTHER_ORTHODONTIC_PURCHASES: "Otras compras de ortodoncia",
  FAQS: "Preguntas frecuentes",
  //MAC BOB
  BUYING_FOR: "Comprar para",
  BUY_ON_BEHALF: "Compra como representante de",
  RETURN_TO_HEADQUARTERS: "Devolver a oficina central",

  //Shopping cart
  SHOPPING_CART: "Carrito",
  PRINT_QUOTE: "Imprimir presupuesto",
  CART_LOCKED: "Carrito bloqueado",
  CART_UNLOCKED: "Carrito desbloqueado",
  SELECT_ITEMS: "Seleccione los elementos para",
  APPLY_A_DISCOUNT: "Aplicar un descuento",
  APPLY_DISCOUNT: "Aplicar descuento",
  DELETE: "Borrar",
  ESTIMATED_SUBTOTAL: "Subtotal estimado",
  ITEMS: "Artículos",
  SHIPPING_MESSAGE:
    "El envío y los impuestos se estimarán después de que se realice su pedido",
  PROCEED_TO_CHECKOUT: "Proceder al pago",
  NET_PRICE_DESCRIPTION:
    "Su precio neto incluye su programa de precios personalizado",
  TYPE: "Tipo",
  SIZE: "Tamaño",
  QUANTITY: "Cantidad",
  EDIT_ORDER: "Editar orden",
  COMMENTS: "Comentarios",
  CART_EMPTY_MESSAGE: "¡Su carrito está vacío!",
  SHOP_YOUR_FAVORITES: "Compra tus favoritas",
  SHOP_ORDER_HISTORY: "Historial de pedidos de la tienda",
  LOADING_YOUR_CART: "Cargando tu carrito...",
  THE_ORDER_IS_LOCKED:
    "El pedido está bloqueado. Para editar el pedido, comuníquese con su representante de campo de Solventum que figura en la página Contáctenos.",
  THE_ORDER_IS_UNLOCK:
    "El pedido está desbloqueado, haga clic en Bloquear para editar el pedido.",
  TO_APPLY_A_DISCOUNT:
    "Para aplicar un descuento, seleccione uno o más productos y un código de descuento.",

  //Checkout page
  CHECKOUT: "Verificar",
  PLACE_ORDER: "Realizar pedido",
  SHIPPING_CONTACT_INFO_HEADER: "Información de envío y contacto",
  PLACING_ORDER_HEADER: "¿Quién realiza este pedido?",
  SHIPPING_ADDRESS: "Dirección de envío",
  PRIMARY_CONTACT_INFO_HEADER: "Información de contacto principal",
  CONFIRMATION_HEADER:
    "¿Le gustaría enviar un correo electrónico de confirmación a alguien más?",
  RECIPIENT_EMAIL_HEADER: "Correo electrónico de la destinataria",
  ENTER_EMAIL: "Ingrese correo electrónico",
  ADD_RECIPIENT: "Agregar destinataria",
  ADD_RECIPIENT_EMAIL_MESSAGE:
    "Por favor agregue la dirección de correo electrónico del destinatario",
  VALID_EMAIL_ADDRESS_MESSAGE:
    "Por favor ingrese una dirección de correo electrónico válida",
  PAYMENT_INFO_HEADER: "Información del pago",
  CARD: "Tarjeta",
  ACH: "ACH",
  BILL_MY_ACCOUNT: "Facturar mi cuenta",
  YOUR_CARDS: "Tus cartas",
  EXPIRES: "Caduca",
  NO_CARD_MESSAGE: "Actualmente no tienes tarjetas registradas.",
  ADD_CARD_MESSAGE:
    "Agregue una tarjeta o seleccione un método de pago diferente para realizar su pedido.",
  ADD_NEW_CARD: "Agregar nueva tarjeta",
  ADD_CARD: "Agregar tarjeta",
  ACH_PAYMENT_HEADER: "Sus opciones de pago ACH",
  NO_ACH_MESSAGE:
    "Actualmente no tienes ningún método de pago ACH configurado.",
  ADD_ACH_MESSAGE:
    "Agregue una cuenta ACH o seleccione un método de pago diferente para realizar su pedido.",
  ADD_NEW_ACH: "Agregar nueva ACH",
  ADD_ACH: "Agregar ACH",
  PAYMENT_TERMS: "Términos de pago",
  DEFAULT_PAYMENT_METHOD: "método de pago por defecto",
  BILLING_ADDRESS: "Dirección de Envio",
  NO_BILL_MY_ACCOUNT_MESSAGE:
    "Actualmente no estás configurado para la facturación de la cuenta.",
  CUSTOMER_SERVICE_MESSAGE:
    "Póngase en contacto con el servicio de atención al cliente o seleccione un método de pago diferente para realizar su pedido.",
  REVIEW_PURCHASE_HEADER: "Revisar compra",
  PO_NUMBER_LABEL: "¿Tiene un número de pedido para este pedido?",
  SPECIAL_INSTRUCTIONS_LABEL:
    "¿Tiene alguna instrucción especial para este pedido?",
  CHARACTER_LIMIT_MESSAGE: "Introduzca hasta 255 caracteres.",
  CHARACTERS_LEFT: "Personajes restantes:",
  REVIEW_ITEMS_MESSAGE:
    "Revise los artículos por última vez antes de realizar su pedido.",
  UNIT_PRICE: "Precio unitario",
  LIST_PRICE: "Precio de lista",
  LIST_UNIT_PRICE: "Precio unitario de lista",
  NET_UNIT_PRICE: "Precio unitario neto",
  NET_PRICE: "Precio neto",
  TOTAL_PRICE: "Precio unitario total",
  CUSTOM_BANDS_HEADER: "Bandas soldadas personalizadas (bandas recetadas)",
  EDIT_ITEMS_MESSAGE: "Editar artículos en el carrito",
  EMAIL_VALIDATION_MESSAGE:
    "Por favor ingrese su correo electrónico para realizar su pedido.",
  PAYMENT_VALIDATION_MESSAGE:
    "Seleccione el método de pago para realizar su pedido.",
  PAYMENT_METHOD_NOT_AVAILABLE_MESSAGE:
    "Este método de pago no está disponible para esta cuenta. Seleccione un método de pago diferente o comuníquese con atención al cliente.",
  PAYMENT_SETUP_INIT_FAILED_MESSAGE:
    "No se pudo inicializar la configuración del pago para esta cuenta. Seleccione un método de pago diferente o comuníquese con atención al cliente.",
  ENTER_PO_NUMBER: "Ingrese el número de orden de compra",
  DESCRIBE_YOUR_REQUEST: "Describe tu solicitud aquí...",
  PREPARING_YOUR_ORDER: "Preparando tu pedido...",
  RESTORE_DEFAULT_RECIPIENT: "Restaurar destinatario predeterminado",
};
